import React from "react";
import {createUseStyles} from "react-jss";
import {Logo} from "./Logo";
import {Button} from "./Button";
import {LogOut} from "lucide-react";
import {DmLogo} from "./DmLogo";
import {useScrollytellTranslation} from "../Admin/scrollytellContext";

const useStyles = createUseStyles({
  appBar: {
    height: 64,
    flex: "0 0 auto",
    background: ({ backgroundColor }) => backgroundColor || "#F6F5F8",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: ({ mode }) => (mode === "dark" ? "#ffffff" : "#000000"),
    fontSize: "14px",
    cursor: "default",
    zIndex: 20,
    position: ({ isAdminMode }) => (isAdminMode ? "sticky" : "sticky"),
    top: 0,
    width: "100%",
    fontFamily: "Inter, sans-serif"
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    margin: "0 10px",
  },
  logo: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& > a": {
      margin: "0 10px",
    },
    "& > div": {
      display: "flex",
      flexDirection: "column",
      "& > a": {
        textDecoration: "none",
        color: "inherit",
        "&:first-of-type": {
          fontWeight: "bold",
        },
      },
      "@media (max-width: 700px)": {
        display: "none",
      },
    },
  },
});

export const AppBar = ({
  backgroundColor,
  mode = "light",
  className = "",
  exhibition,
  museum,
  onClose,
  isAdminMode,
  children,
}) => {
  const styles = useStyles({
    backgroundColor: backgroundColor,
    mode: mode,
    isAdminMode: isAdminMode
  });
  const t = useScrollytellTranslation()

  return (
    <header className={`${styles.appBar} ${className}`}>
      {isAdminMode ? (
        <div className={styles.logo}>
          <div>
            <Logo showLabel={false} mode={mode} />
          </div>
          <div>
            {exhibition?.name && <span>{exhibition.name}</span>}
            {museum?.name && <span>{museum.name}</span>}
          </div>
        </div>
      ) : (
        <div className={styles.logo}>
          <a href="/" aria-label={t("homeLink", "Forside")}>
            <DmLogo
                mode={mode}
            />
          </a>
          <div>
            {exhibition?.name && <a href={exhibition.url}>{exhibition.name}</a>}
            {museum?.name && <a href={museum.url}>{museum.name}</a>}
          </div>
        </div>
      )}
      <div className={styles.buttons}>
        {children}
        {onClose && (
          <Button
            text={t('closeButton', 'Avslutt')}
            icon={<LogOut />}
            onClick={onClose}
            mode={mode}
          />
        )}
      </div>
    </header>
  );
};
